"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cache_1 = require("./cache");
/**
 * CustomEvent Polyfill for IE
 */
(function () {
    if (typeof window.CustomEvent === 'function')
        return false;
    function CustomEvent(event, params) {
        params = params || { bubbles: false, cancelable: false, detail: null };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }
    window.CustomEvent = CustomEvent;
})();
/**
 * Trigger customEvent icestark:not-found
 */
exports.default = (function () {
    if (cache_1.getCache('root')) {
        window.dispatchEvent(new CustomEvent('icestark:not-found'));
        // Compatible processing return renderNotFound();
        return null;
    }
    return 'Current sub-application is running independently';
});
